import React from "react";
import { Languages } from "lucide-react";
import { useI18n } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageToggle() {
  const { lang, setLang } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-toggle"
          className="inline-flex h-9 items-center gap-1.5 rounded-md border border-border px-2.5 text-sm text-foreground/80 transition-colors hover:bg-secondary active:scale-95"
        >
          <Languages className="h-4 w-4" />
          <span className="uppercase font-mono text-xs">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem data-testid="lang-en" onClick={() => setLang("en")}>
          English
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="lang-it" onClick={() => setLang("it")}>
          Italiano
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
